var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirConditioning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46663 1.22355C6.46663 0.801939 6.13537 0.500789 5.68364 0.561019C4.26824 0.9224 3.12387 2.21735 3.09375 3.78333C3.09375 5.34931 4.14778 6.64426 5.68364 7.00564C6.10525 7.09598 6.46663 6.76472 6.46663 6.34311C6.46663 5.13851 6.46663 2.5185 6.46663 1.22355Z",
    fill: "#858595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94849 13.3297C6.94849 13.7513 7.27975 14.0525 7.73148 13.9923C9.14688 13.6309 10.2913 12.3359 10.3214 10.7699C10.3214 9.20397 9.26734 7.90902 7.73148 7.54764C7.30987 7.4573 6.94849 7.72833 6.94849 8.21017C6.94849 9.41477 6.94849 12.0649 6.94849 13.3297Z",
    fill: "#858595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.821 7.06576C13.2426 7.06576 13.5437 6.73449 13.4835 6.28277C13.1221 4.86736 11.8272 3.72299 10.2612 3.69287C8.69521 3.69287 7.40026 4.7469 7.03888 6.28277C6.94854 6.70438 7.2798 7.06576 7.70141 7.06576C8.81567 7.06576 11.5561 7.06576 12.821 7.06576Z",
    fill: "#858595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.624306 7.57776C0.202696 7.57776 -0.0984542 7.90902 -0.0382241 8.36075C0.323156 9.77616 1.6181 10.9205 3.18408 10.9506C4.75007 10.9506 6.04501 9.89662 6.40639 8.36075C6.49674 7.93914 6.16547 7.57776 5.74386 7.57776C4.62961 7.57776 1.91925 7.57776 0.624306 7.57776Z",
    fill: "#858595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditioning);
export default __webpack_public_path__ + "static/media/AirConditioning.1298b1fb91f36425fc911ca27af26d50.svg";
export { ForwardRef as ReactComponent };